export const gerarCashbackId = () => {
    const letras = Array(4)
      .fill(0)
      .map(() => String.fromCharCode(65 + Math.floor(Math.random() * 26)));
  
    const numeros = Math.floor(1000 + Math.random() * 9000);
    return `cbk-${letras.join("")}-${numeros}`;
  };